module.exports = __webpack_public_path__ + "static/award2_202107-a8e5f878d1743c2b8f6d8efc9fe008a0.png";